module.exports = __webpack_public_path__ + "img/capa1.bccede19.png";